import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import type { ButtonProps } from "./Button";

const THEME_RELATED_VIEWS = [
  "siteStyles",
  "siteThemeList",
  "siteColorsList",
  "h1TextStyles",
  "h2TextStyles",
  "h3TextStyles",
  "h4TextStyles",
  "h5TextStyles",
  "h6TextStyles",
  "p1TextStyles",
  "p2TextStyles",
  "p3TextStyles",
  "primaryButton",
  "secondaryButton",
  "design",
  "brand",
  "buttonStyles",
  "textStyles",
] as const;

type ThemeRelatedView = (typeof THEME_RELATED_VIEWS)[number];

const isThemeRelatedView = (view: unknown): view is ThemeRelatedView =>
  typeof view === "string" &&
  THEME_RELATED_VIEWS.includes(view as ThemeRelatedView);

export const ThemeConfigurationButton = ({
  className,
  ...rest
}: ButtonProps) => {
  const toggleSidebarView = useBuilderStore(state => state.toggleSidebarView);
  const actionSidebarView = useBuilderStore(state => state.actionSidebarView);
  const isThemeConfigurationActive = isThemeRelatedView(actionSidebarView);

  return (
    <IconButton
      name={
        isThemeConfigurationActive
          ? "24-builder-ui-sidebar-theme-configuration-filled"
          : "24-builder-ui-sidebar-theme-configuration"
      }
      iconSize={24}
      buttonSize={32}
      ariaLabel={t("builder_ui.theme_configuration.label")}
      className={classNames(className, {
        "bg-tertiary": isThemeConfigurationActive,
      })}
      iconClassName="!text-dark"
      onClick={() => {
        toggleSidebarView("design");
      }}
      data-testid="builder-ui-theme-configuration-button"
      {...rest}
    />
  );
};
